import styled from 'styled-components'
import { addMediaQuery } from '../../../_constants/stylesMediaBreakpoints'
import { S_FeeSummary } from './FeeSummary.styles'

export const S_FeeSummaryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 12px -8px 0 -8px;

  ${addMediaQuery.xs`
        margin: 15px 0 0 0;
    `}
  ${S_FeeSummary} {
    width: calc(33.3% - 16px);
    margin: 8px;
    ${addMediaQuery.sm`
        width: calc(50% - 16px);
      `}
    ${addMediaQuery.xs`
        width: 100%;
        margin: 8px 0;
      `}
  }
`
